import gql from 'graphql-tag'

export default gql`
  query RouteAdminReelFeedbackIndexQuery {
    reelFeedbacks(first: 500) {
      edges {
        node {
          id
          positive
          text
          insertedAt

          video {
            title
          }

          user {
            email
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/routes/admin/feedback/reel_feedback/index.query.js